import { SharedApiV2 } from "mock-api/src/public-api";
import { UUID } from "src/utils";

export class HelpAssistTicketUser {
  private constructor(args: ClassProperties<HelpAssistTicketUser>) {
    this.carrierId = args.carrierId;
    this.emailAddress = args.emailAddress;
    this.userDisplayName = args.userDisplayName;
    this.userId = args.userId;
  }
  public readonly carrierId: number | null;
  public readonly emailAddress: string | null;
  public readonly userDisplayName: string;
  public readonly userId: UUID;

  public static deserialize(
    apiModel: SharedApiV2.TicketUserDto,
  ): HelpAssistTicketUser {
    return {
      carrierId: apiModel.carrierId ?? null,
      emailAddress: apiModel.emailAddress ?? null,
      userDisplayName: apiModel.userDisplayName,
      userId: new UUID(apiModel.userId),
    };
  }
}
